import BaseAPIRepository, { BaseAPIResponse } from 'api/base';
import { AxiosResponse } from 'axios';
import { BASE_URL } from 'const';
import { FERequestErrorsHandler } from 'utils';
import { GetCatalogCategoriesRequestV1, GetCatalogProductsRequestV1 } from '.';

import {
  GetCatalogCategoriesResponseV1,
  GetCatalogProductsResponseV1,
} from '.';

const catalogRepositoryV1 = {
  getCatalogProducts: (
    { request, cityId, catalogId }: GetCatalogProductsRequestV1,
    signal?: AbortSignal,
  ) =>
    new Promise<GetCatalogProductsResponseV1.ListResponse>(
      async (resolve, reject) => {
        try {
          let url: string;
          if (request) {
            const { query, limit, offset, sortName, sortDirection } = request;
            url =
              `${BASE_URL}/not-secure/api/v1/catalogs/${catalogId}/products?cityId=${cityId}` +
              `${query ? `&query=${query}` : ''}` +
              `${limit ? `&limit=${limit}` : ''}` +
              `${offset ? `&offset=${offset}` : ''}` +
              `${query ? `&query=${query}` : ''}` +
              `${sortDirection ? `&sortDirection=${sortDirection}` : ''}` +
              `${sortName ? `&sortName=${sortName}` : ''}`;
          } else
            url = `${BASE_URL}/not-secure/api/v1/catalogs/${catalogId}/products?cityId=${cityId}`;
          let result: AxiosResponse<
            BaseAPIResponse<GetCatalogProductsResponseV1.ListResponse>
          > = await BaseAPIRepository.get<
            BaseAPIResponse<GetCatalogProductsResponseV1.ListResponse>
          >(url, { signal });
          resolve(result.data.result);
        } catch (error: any) {
          FERequestErrorsHandler(error, reject);
        }
      },
    ),

  getCatalogCategories: (
    { request, catalogId }: GetCatalogCategoriesRequestV1,
    signal?: AbortSignal,
  ) =>
    new Promise<GetCatalogCategoriesResponseV1.ListResponse>(
      async (resolve, reject) => {
        try {
          let url: string;
          if (request) {
            const { query, limit, offset, sortName, sortDirection } = request;
            url =
              `${BASE_URL}/not-secure/api/v1/catalogs/${catalogId}/categories?` +
              `${query ? `query=${query}` : ''}` +
              `${limit ? `&limit=${limit}` : ''}` +
              `${offset ? `&offset=${offset}` : ''}` +
              `${query ? `&query=${query}` : ''}` +
              `${sortDirection ? `&sortDirection=${sortDirection}` : ''}` +
              `${sortName ? `&sortName=${sortName}` : ''}`;
          } else
            url = `${BASE_URL}/not-secure/api/v1/catalogs/${catalogId}/categories`;
          let result: AxiosResponse<
            BaseAPIResponse<GetCatalogCategoriesResponseV1.ListResponse>
          > = await BaseAPIRepository.get<
            BaseAPIResponse<GetCatalogCategoriesResponseV1.ListResponse>
          >(url, { signal });
          resolve(result.data.result);
        } catch (error: any) {
          FERequestErrorsHandler(error, reject);
        }
      },
    ),
};

export default catalogRepositoryV1;
